export class SameSourceAccountRestoreLimits {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "dataAccessRuleId",
            "baseName": "dataAccessRuleId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SameSourceAccountRestoreLimits.attributeTypeMap;
    }
    constructor() {
    }
}
